import React, { useState, useRef, useEffect } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import ScrollContainer from "react-indiana-drag-scroll";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import placeHolderImg from "../../Assets/Images/placeholder.png";
import play from "../../Assets/Images/static/play.png";
import img1 from "../../Assets/Images/static/story1.jpg";
import banner1 from "../../Assets/Images/static/image1.png";
import playwhite from "../../Assets/Images/static/play-white.png";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import moment from "moment";

export const ListPreview = ({
  list,
  updateOpenArrayState,
  sectionId,
  template,
  title,
}) => {
  const spanStyle = {
    padding: "10px",
    background: "#efefef",
    color: "#000000",
    width: "50%",
    textAlign: "center",
  };
  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    height: "150px",
    borderRadius: "7px",
    border: "1px solid #e6e7e8",
    marginRight: "0.4rem",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const buttonStyle = {
    width: "30px",
    background: "none",
    border: "0px",
  };

  const properties = {
    prevArrow: (
      <button style={{ ...buttonStyle }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="#fff"
        >
          <path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" />
        </svg>
      </button>
    ),
    nextArrow: (
      <button style={{ ...buttonStyle }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="#fff"
        >
          <path d="M512 256L270 42.6v138.2H0v150.6h270v138z" />
        </svg>
      </button>
    ),
  };
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="mt-3 containerPreviewRichText">
      {" "}
      <div className="slide-container">
        {template === "Stories" ? (
          <div className="d-flex overflow-auto">
            {list.map((slideImage, index) => (
              <div className="text-center" key={index}>
                <img
                  src={
                    slideImage.image.en ? slideImage.image.en : placeHolderImg
                  }
                  alt=""
                  className="rounded-circle mx-2  object-fit-cover"
                  width="70px"
                  height="70px"
                />
                <small>{slideImage.title.en ? slideImage.title.en : ""}</small>
              </div>
            ))}
          </div>
        ) : template === "Top artists" ? (
          <div className="d-flex flex-column overflow-auto bg-white rounded py-3 px-2">
            <div className="mb-2">
              <b style={{ color: "#101010", fontsize: 16 + "px" }}>{title}</b>
            </div>
            <div className="d-flex">
              {list.map((slideImage, index) => (
                <div className="text-center position-relative" key={index}>
                  <img
                    src={
                      slideImage.image.en ? slideImage.image.en : placeHolderImg
                    }
                    alt=""
                    className="rounded-circle mx-2  object-fit-cover"
                    width="70px"
                    height="70px"
                  />
                  {/* <div className="d-flex align-center justify-content-center notification-circle rounded-circle bg-white position-absolute top-0 end-0">
                  <p>40</p>
                </div> */}
                  <small>
                    {slideImage.title.en ? slideImage.title.en : ""}
                  </small>
                </div>
              ))}
            </div>
          </div>
        ) : template === "Banners" || template === "Wide Banners" ? (
          <div className="text-center my-4">
            <img
              src={
                list && list?.length && list[0]?.image.en
                  ? list[0]?.image.en
                  : ""
              }
              alt=""
              className="rounded"
              width="100%"
            />
          </div>
        ) : template === "Video1x3" ? (
          <div className="d-flex my-4">
            {list.slice(0, 3).map((element, index) => (
              <div
                style={{ width: 33 + "%" }}
                className="position-relative mx-1"
              >
                <img
                  className="w-100 object-fit-cover"
                  style={{ height: 200 + "px" }}
                  src={element?.image?.en ? element?.image?.en : ""}
                ></img>
                <img
                  className="position-absolute top-0 start-0 bottom-0 end-0 m-auto"
                  src={play}
                  alt=""
                />
              </div>
            ))}
          </div>
        ) : template === "VideoSlider" ? (
          <div>
            <Slide transitionDuration={200} duration={100000} arrows={false}>
              <div className="d-flex mt-2">
                {list.slice(0, 2).map((slideImage, index) => (
                  <div className=" mx-1 w-50" key={index}>
                    <div className="border position-relative">
                      <img
                        className="d-inline-flex"
                        style={{
                          width: "100" + "%",
                          height: 165 + "px",

                          backgroundImage: `url(${
                            slideImage.image?.en
                              ? slideImage.image?.en
                              : placeHolderImg
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                        alt=""
                      />
                      <img
                        className="position-absolute top-0 start-0 bottom-0 end-0 m-auto"
                        src={playwhite}
                        alt=""
                      />
                    </div>
                    <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                      {slideImage?.title?.en ? slideImage.title.en : ""}
                    </p>
                  </div>
                ))}
              </div>
            </Slide>
          </div>
        ) : template === "Collections" ? (
          <div>COLLECTIONS</div>
        ) : template === "ImageWithText" ? (
          <div>
            {list.map((element, index) =>
              index % 2 !== 0 ? (
                <div class="d-flex align-items-center my-2" key={index}>
                  <div className="w-50">
                    <img
                      className="w-100  object-fit-cover"
                      height="70px"
                      src={element.image?.en ? element.image?.en : ""}
                    />
                  </div>
                  <div
                    style={{ height: 100 + "px" }}
                    className="ps-2 w-50  bg-white d-flex align-items-center"
                  >
                    <h1>
                      <b>{element.title?.en ? element.title?.en : ""}</b>
                    </h1>
                  </div>
                </div>
              ) : (
                <div class="d-flex align-items-center my-2">
                  <div
                    style={{ height: 100 + "px" }}
                    className="ps-2 w-50  bg-white d-flex align-items-center"
                  >
                    <h1>
                      <b>{element.title?.en ? element.title?.en : ""}</b>
                    </h1>
                  </div>
                  <div className="w-50">
                    <img
                      className="w-100  object-fit-cover"
                      height="100px"
                      src={element.image?.en ? element.image?.en : ""}
                    />
                  </div>
                </div>
              )
            )}

            {/* <div class="d-flex align-items-center my-2">
              <div className="w-50">
                <img
                  className="w-100  object-fit-cover"
                  height="70px"
                  src={img1}
                />
              </div>
              <div
                style={{ height: 70 + "px" }}
                className="ps-2 w-50  bg-white d-flex align-items-center"
              >
                <h1>
                  <b>HOT DEALS</b>
                </h1>
              </div>
            </div>

            <div class="d-flex align-items-center my-2">
              <div
                style={{ height: 70 + "px" }}
                className="ps-2 w-50  bg-white d-flex align-items-center"
              >
                <h1>
                  <b>HOT DEALS</b>
                </h1>
              </div>
              <div className="w-50">
                <img
                  className="w-100  object-fit-cover"
                  height="70px"
                  src={img1}
                />
              </div>
            </div> */}
          </div>
        ) : template === "TallBanners" ? (
          <div className="mb-5">
            <Slide transitionDuration={200} duration={100000} arrows={false}>
              <div className="d-flex mt-2">
                <div className=" mx-1 w-100">
                  <div className="position-relative d-flex">
                    {list.length && list[0] && (
                      <img
                        className="d-inline-flex rounded"
                        style={{
                          width: "500" + "%",
                          height: 300 + "px",

                          backgroundImage: `url(${
                            list[0].image?.en ? list[0].image?.en : ""
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                        alt=""
                      />
                    )}

                    {list.length && list[1] && (
                      <img
                        className="d-inline-flex rounded"
                        style={{
                          width: "100" + "%",
                          height: 300 + "px",
                          marginLeft: 10 + "px",
                          backgroundImage: `url(${
                            list[1].image?.en ? list[1].image?.en : ""
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                        alt=""
                      />
                    )}
                  </div>
                </div>
              </div>
            </Slide>
          </div>
        ) : (
          <div className="slide-container">
            <Slide
              slidesToShow={1}
              arrows={true}
              transitionDuration={200}
              {...properties}
            >
              {list.map((slideImage, index) => (
                <div key={index} arrows={false}>
                  <div
                    className="mb-2"
                    style={{
                      ...divStyle,
                      backgroundImage: `url(${
                        slideImage.image.en ? slideImage.image.en : ""
                      })`,
                    }}
                  ></div>
                  <p
                    style={{
                      color: "#101010",
                      fontsize: 13 + "px",
                      textAlign: "center",
                    }}
                  >
                    {slideImage.title?.en ? slideImage.title?.en : ""}
                  </p>
                </div>
              ))}
            </Slide>
          </div>
          // <ImageGallery
          //   items={list.map((element, index) => {
          //     return {
          //       original: element.image.en ? element.image.en : placeHolderImg,
          //       description: element?.title && element?.title?.en,
          //       originalHeight: "300px",
          //     };
          //   })}
          //   showFullscreenButton={false}
          //   showPlayButton={false}
          //   showBullets={true}
          //   showThumbnails={false}
          //   showNav={false}
          // />
          // <Slide transitionDuration={200} duration={100000}>
          //   {list.map((slideImage, index) => (
          //     <div key={index}>
          //       <div
          //         style={{
          //           ...divStyle,
          //           backgroundImage: `url(${
          //             slideImage.image.en ? slideImage.image.en : placeHolderImg
          //           })`,
          //         }}
          //       >
          //         {slideImage?.title && slideImage?.title?.en && (
          //           <span style={spanStyle}>{slideImage.title.en}</span>
          //         )}
          //       </div>
          //     </div>
          //   ))}
          // </Slide>
        )}
      </div>
      <div className="overlay4" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};
